import type {
  INeoActionExecutionController,
  INeoActionExecutionService,
} from "../../core/ports/driver/neoActionExecutionService";

/**
 * Neo Action Executions controller. Exposes the service surface directly (no
 * extra presentation-layer adaptation), kept as its own factory for
 * consistency with the rest of the hexagon (page → controller → service →
 * repository).
 */
export const NeoActionExecutionControllerFactory = ({
  neoActionExecutionService,
}: {
  neoActionExecutionService: INeoActionExecutionService;
}): INeoActionExecutionController => {
  return {
    listActionExecutions: neoActionExecutionService.listActionExecutions,
    approveActionExecution: neoActionExecutionService.approveActionExecution,
    rejectActionExecution: neoActionExecutionService.rejectActionExecution,
    undoActionExecution: neoActionExecutionService.undoActionExecution,
  };
};
